import React from "react";
import Navigation from "../Navigation/Navigation";

function Revision() {
  return (
    <React.Fragment>
      <Navigation select="revision" />
      <h1>Still working on this</h1>
    </React.Fragment>
  );
}

export default Revision;
